export default "__VITE_ASSET__CY1TsWIe__"